import { render, staticRenderFns } from "./EditMenuGroup.vue?vue&type=template&id=74b438c6&scoped=true"
import script from "./EditMenuGroup.vue?vue&type=script&lang=js"
export * from "./EditMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./EditMenuGroup.vue?vue&type=style&index=0&id=74b438c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b438c6",
  null
  
)

export default component.exports